module.exports = __webpack_public_path__ + "static/media/banner2.e8e0a0c4.jpg";